export class ModalsNames {
    public static ftue = "";

    /**
     * fills the class fields by unique name
     */
    constructor() {
        Object.keys(ModalsNames).forEach(key => {
            ModalsNames[key] = this.constructor.name + "_" + key;
            console.log(ModalsNames[key]);
        });
    }
}
